import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
// import events1 from "../../assets/Images/events-pics/events1.jpg";
// import events2 from "../../assets/Images/events-pics/events2.jpg";
// import events3 from "../../assets/Images/events-pics/events3.jpg";
// import events4 from "../../assets/Images/events-pics/events4.jpg";
import events5 from "../../assets/Images/events-pics/events5.jpg";
import events6 from "../../assets/Images/events-pics/events6.jpg";
import events7 from "../../assets/Images/events-pics/events8.jpg";


import Slideshow from "../../assets/Slideshow/Slideshow"; 


import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";



const Lo5AttendingEvents = () => {
    const navigate = useNavigate();
    const images = [events5, events6, events7];

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo5-headings">
                <h1>Attending Events</h1>
                <p>Throughout this semester I try to attend events given by Fontys to </p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                                <BreadcrumbHeader />
                        </div>
            <div className="content-lo5">
                <div className="content-lo5-attending">
                    <div className="content-lo5-attending-text">
                    {/* <img src={gif2}></img> */}
                        <h1>We are Playgrounds</h1>
                        <p>
                            Unfortunately, I wasn't able to attend this event in person due to being sick.
                            However, I made sure to stay updated by asking my groupmate with what happened during the events.
                            the event took place at Strijp-S and featured a wide range of digital artwork from the professionals.
                            I did regret not coming because from what I've heard from my group mate Adib this event was pretty
                            insightful.
                        </p>
                        <h1>Career Day</h1>
                        <p>
                            Career Day took place at the TQ Building in Strijp-S, and it featured booths from companies in media,
                            tech, and design. Although I explored some of the job stands, what really caught my attention was the
                            exhibition of Semester 4 projects. Seeing the booth for the minor mobile app development makes me excited for the next semester.
                        </p>
                        
                    </div>

                    <div className="content-lo5-attending-slideshow">
                        <Slideshow images={images} />

                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo5AttendingEvents;